import axios from "../utils/axios";
import { requests } from "../utils/urls";


export const setShopWage = async ({ shopId, ...data }) => {
  try {
    const res = await axios({
      method: 'POST',
      url: requests.management.shopWage.setShopWage + `${shopId}`,
      data
    });
    return res;
  } catch (e) {
    return e
  }

};
export const viewShop = async ({ id }) => {
  const res = await axios({
    method: 'GET',
    url: requests.management.shop.getById + `/${id}`,
    // params: `/:${id}`
  });

  return res;
};
export const getShops = async () => {
  const res = await axios({
    method: 'GET',
    url: requests.management.shop.getAll,
  });

  return res;
};
export const AddShop = async ({
  name,
  logo,
  header,
  wage,
  has_in_person,
  price_per_km,
  has_courier,
  descriptions,
  categories,
  meal_tags,
  payment_methods,
  call_numbers,
  full_address,
  // postal_code,
  latitude,
  longitude,
  uuid,
  is_active,
  price,
  predefine_geofences,
}) => {
  const frmData = new FormData();
  frmData.append('name', name);
  frmData.append('wage', wage);
  frmData.append('has_in_person', has_in_person);
  frmData.append('has_courier', has_courier);
  frmData.append('price_per_km', price_per_km);
  frmData.append('descriptions', descriptions);
  frmData.append('address[full_address]', full_address);
  // frmData.append('address[postal_code]', postal_code);
  frmData.append('address[latitude]', latitude);
  frmData.append('address[longitude]', longitude);
  for (let i = 0; i < uuid.length; i++) {
    frmData.append(`predefine_geofences[${i}][uuid]`, uuid[i]);
    frmData.append(`predefine_geofences[${i}][is_active]`, is_active[i]);
    frmData.append(`predefine_geofences[${i}][price]`, price[i]);
  }
  for (let i = 0; i < categories.length; i++) {
    frmData.append('categories[]', categories[i]);
  }
  for (let i = 0; i < meal_tags.length; i++) {
    frmData.append('meal_tags[]', meal_tags[i]);
  }
  for (let i = 0; i < payment_methods.length; i++) {
    frmData.append(`payment_methods[${i}]`, payment_methods[i]);
  }
  for (let i = 0; i < call_numbers.length; i++) {
    frmData.append(`call_numbers[${i}][value]`, call_numbers[i]);
  }
  if (logo) {
    frmData.append('logo', logo);
  }
  if (header) {
    frmData.append('header', header);
  }
  try {
    const res = await axios({
      headers: {
        'Content-Type': '"multipart/form-data","application/json"',
      },
      method: 'POST',
      url: requests.management.shop.create,
      data: frmData,
    });

    return res;
  } catch (e) {
    return e;
  }

};
export const editShopLogo = async ({ logo, id }) => {
  const frmData = new FormData();
  // const form_data = formDataCreator(logo)
  if (logo) {
    if (typeof logo === 'string') {
      delete values['logo']
    }
    frmData.append('logo', logo);
  }
  const res = await axios({
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    method: 'POST',
    url: requests.management.shopSettings.editLogo + `${id}/logo`,
    data: frmData,
    params: { _method: 'PATCH' },
  });

  return res;
};
export const editShopHeader = async ({ header, id }) => {
  const frmData = new FormData();
  // const form_data = formDataCreator(logo)
  if (header) {
    if (typeof header === 'string') {
      delete values['header']
    }
    frmData.append('header', header);
  }
  const res = await axios({
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    method: 'POST',
    url: requests.management.shopSettings.editHeader + `${id}/header`,
    data: frmData,
    params: { _method: 'PATCH' },
  });

  return res;
};



export const editShopGeofance = async (shopId, geoId, data) => {
  try {
    const res = await axios({
      method: 'PATCH',
      url: requests.management.shop.getAll + `/${shopId}` + `/geofence/` + `${geoId}`,
      data,
    });

    return res;
  } catch (e) {
    return e;
  }
};

export const createShopGeofance = async (shopId, data) => {
  const res = await axios({
    method: 'POST',
    url: requests.management.shop.getAll + `/${shopId}` + `/geofence`,
    data,
  });
  return res
}



export const getWorkingHours =  async (shopId) => {
  try {
    const res = await axios({
      method: 'GET',
      url: requests.management.shop.WorkingHours.getAll(shopId),
    });

    return res;
  } catch (e) {
    return e;
  }
};

export const createWorkingHours =  async (data) => {
  try {
    const res = await axios({
      method: 'POST',
      url: requests.management.shop.WorkingHours.getAll,
      data
    });

    return res;
  } catch (e) {
    return e;
  }
};
